/**
 * Created by neo on 22.11.2023
 */
import { makeAutoObservable } from 'mobx';
import { Audited, createAuditedFields } from '../../Audited';
import { HttpBackend } from '../../../Services/Http/HttpBackend';
import { Media, createMedia } from '../../Media/Media';

export type RouteChallengeTeamMember = Audited & {
  teamId: string;
  challengeId: string;
  gymId: string;
  customerId: string;
  athleteId: string;
  isAdmin: boolean;
  username: string;
  profileImage?: Media;
  totalCollectedPoints: number;
  extraCollectedPoints?: number | null;
  remove(): Promise<RouteChallengeTeamMember>;
};

export function createRouteChallengeTeamMember(json?: Partial<RouteChallengeTeamMember>): RouteChallengeTeamMember {
  const audited = createAuditedFields(json);
  const member: RouteChallengeTeamMember = makeAutoObservable({
    ...audited,
    teamId: json?.teamId ?? '',
    challengeId: json?.challengeId ?? '',
    gymId: json?.gymId ?? '',
    customerId: json?.customerId ?? '',
    athleteId: json?.athleteId ?? '',
    isAdmin: json?.isAdmin ?? false,
    username: json?.username ?? '',
    profileImage: json?.profileImage ? createMedia(json.profileImage as any) : undefined,
    totalCollectedPoints: json?.totalCollectedPoints ?? 0,
    extraCollectedPoints: json?.extraCollectedPoints ?? null,

    remove(): Promise<RouteChallengeTeamMember> {
      return HttpBackend.delete(`/coach-program/engagement/route-challenges/teams/${this.teamId}/members/${this.id}`);
    },
  });

  return member;
}
